import script from "./TokenFarmInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenFarmInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenFarmInput.vue?vue&type=style&index=0&id=1fea68c1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fea68c1"]])

export default __exports__